import axiosClient, { axiosHyperwolfDevClient } from "axiosClient";
import { getQueryString } from "utilities/common";

export async function fetchDistributorsAPI(filters) {
  const statusVal = filters?.status;
  const statusQuery =
    statusVal === 'Active' ? true : statusVal === 'Inactive' ? false : undefined;
  const query = {
    searchTerm: filters?.searchTerm ?? '',
    sortBy: filters?.sortBy ?? 'distributorName',
    order: filters?.order ?? 'desc',
    skip: filters?.skip ?? 0,
    limit: filters?.limit ?? 10,
    ...(statusQuery !== undefined && { status: statusQuery }),
  };
  const res = await axiosHyperwolfDevClient.get(`api/v1/admin/distributor?${getQueryString(query)}`);
  return res?.data ?? res;
}

export async function fetchDistributorDetailsAPI(distributorId, blazeVendorId) {
  const query = blazeVendorId ? `?blazeVendorId=${encodeURIComponent(blazeVendorId)}` : '';
  const res = await axiosHyperwolfDevClient.get(`api/v1/admin/distributor/${distributorId}${query}`);
  return res?.data ?? res;
}

export async function addDistributorAPI(data) {
  const res = await axiosHyperwolfDevClient.post(`api/v1/admin/distributor`, data);
  return res?.data ?? res;
}

/** Update distributor. URL path uses blazeVendorId when provided (not distributorId). Payload: same as add (POST); do not send blazeVendorId in body. */
export async function updateDistributorAPI(data, distributorId, blazeVendorId) {
  const pathId = blazeVendorId || distributorId;
  const res = await axiosHyperwolfDevClient.put(`api/v1/admin/distributor/${pathId}`, data);
  return res?.data ?? res;
}

export async function deleteDistributorAPI(distributorId) {
  const res = await axiosHyperwolfDevClient.delete(`api/v1/admin/distributor/${distributorId}`);
  return res?.data ?? res;
}

export async function syncDistributorAPI() {
  const res = await axiosHyperwolfDevClient.get(`api/v1/admin/distributor/sync/blaze`);
  return res?.data ?? res;
}
